import { z } from 'zod';

/** The SDK build currently served by the platform (technical §16.9, §16.10, §27.7). */
export const sdkArtifactDto = z
  .object({
    version: z.string().max(32),
    /** Immutable, content-addressed file the integration tag points at. */
    url: z.string().url(),
    /** Subresource Integrity value, `sha384-<base64>`. */
    integrity: z.string().regex(/^sha384-[A-Za-z0-9+/]+=*$/),
    gzipBytes: z.number().int().min(0),
  })
  .strict();
export type SdkArtifactDto = z.infer<typeof sdkArtifactDto>;

/** What the "Script" screen shows for one project (functional §5.7, §6.2). */
export const scriptStatusDto = z
  .object({
    projectId: z.string().uuid(),
    /** False while the layer is suspended from the Console. */
    enabled: z.boolean(),
    /** Version served to the SDK; 0 when nothing was ever published. */
    activeVersion: z.number().int().min(0),
    /** Highest published version; equals activeVersion unless a rollback happened. */
    latestVersion: z.number().int().min(0),
    /** Null when the served build cannot be described (SDK not built or unreachable). */
    sdk: sdkArtifactDto.nullable(),
    /** Platform address the SDK talks to, the second parameter of the tag. */
    endpoint: z.string().url(),
    /** The tag to paste in the site template, ready to copy. Null without a described build. */
    tag: z.string().nullable(),
  })
  .strict();
export type ScriptStatusDto = z.infer<typeof scriptStatusDto>;
